import React from "react"
import { connect } from "react-redux"
import {
  getOffices,
  onOfficeResponse,
  onPlanProviderResponse,
  onPlanResponse,
  onHolderResponse,
  submitPlanInformation,
  updatePlanInformation,
  getAllPlanSettings,
  getPlanInformation,
} from "../../../dashboard/actions"
import { config } from "./components/formConfig"
import ProfileForm from "./components/ProfileForm"
import DashboardForm from "./components/DashboardForm"

const PlanDetails = ({ ...props }) => (
  <React.Fragment>
    {props.dashboard && <DashboardForm {...props} config={config} />}
    {props.profile && <ProfileForm {...props} config={config} />}
  </React.Fragment>
)

class PlanDetailsContainer extends React.Component {
  state = {
    isEditing: false,
    loading: false,
    error: null,
    edited: false,
  }

  componentDidMount() {
    if (this.props.dashboard) {
      if (this.props.office.options.length === 0) {
        this.props.getOffices()
      }
    }
    if (this.props.profile && this.props.planInformation) {
      if (this.props.planInformation === true) {
        this.props.getPlanInformation()
      } else {
        this.props.getAllPlanSettings()
      }
    }
  }

  componentDidUpdate(prevProps) {
    if (!this.props.profile) return
    if (this.props.planInformation && this.props.planInformation !== prevProps.planInformation) {
      this.props.getAllPlanSettings()
    }
  }

  save = () => {
    this.setState({ loading: true, error: null })
    return this.props.dashoard ? this.props.submitPlanInformation() : this.props.updatePlanInformation()
      .then(() => {
        this.setState({
          loading: false,
          edited: false,
          isEditing: false
        })
      })
      .catch(() => {
        this.setState({
          error: "Something went wrong. Please try again.",
          loading: false,
        })
      })
  }

  edit = () => {
    if (!this.props.profile) return
    this.setState({
      isEditing: true,
      error: null,
      edited: false,
    })
  }

  cancel = () => {
    if (!this.props.profile) return
    this.props.getAllPlanSettings()
    this.setState({
      isEditing: false,
      error: null,
    })
  }

  getResponseText = (options, selected) => {
    if (!options) return
    let option = options.find(o => o.value === selected)
    return option ? option.text || "" : ""
  }

  isDisabled = () => {
    const { office, planProvider, plan, holder } = this.props
    return !(office.selected && planProvider.selected && plan.selected && holder)
  }

  isPublic = () => {
    const { office } = this.props
    let selectedOffice = office.options.find(o => o.value === office.selected)
    return selectedOffice && selectedOffice.text === "Public"
  }

  render() {
    let disabled = this.isDisabled()
    let isPublic = this.isPublic()
    return (
      <PlanDetails
        {...this.state}
        {...this.props}
        edit={this.edit}
        save={this.save}
        cancel={this.cancel}
        disabled={disabled}
        isEditing={this.props.dashboard || this.state.isEditing}
        getResponseText={this.getResponseText}
        isPublic={isPublic}
      />
    )
  }
}

const mapStateToProps = state => ({
  office: state.dashboard.office,
  planProvider: state.dashboard.planProvider,
  plan: state.dashboard.plan,
  holder: state.dashboard.holder,
  planInformation: state.dashboard.planInformation,
})

const mapDispatchToProps = {
  getOffices: getOffices,
  onOfficeResponse: onOfficeResponse,
  onPlanProviderResponse: onPlanProviderResponse,
  onPlanResponse: onPlanResponse,
  onHolderResponse: onHolderResponse,
  submitPlanInformation: submitPlanInformation,
  updatePlanInformation: updatePlanInformation,
  getAllPlanSettings: getAllPlanSettings,
  getPlanInformation: getPlanInformation,
}

export default connect(mapStateToProps, mapDispatchToProps)(
  PlanDetailsContainer
)



// WEBPACK FOOTER //
// ./assets/common/components/PlanDetails/index.js